<template lang="pug" src="./accessibility.pug"></template>

<script>
import Loader from 'components/loader/loader'
import HeroImage from 'components/hero/hero-image/hero-image'

export default {
  computed: {
    props () {
      return this.$store.state.pages['covid-19']
    },
    loading () {
      return this.$store.state.loading
    }
  },
  components: {
    Loader,
    HeroImage
  },
  data () {
    return {
      companyName: 'Restoration Dental Group', // Fill this in
      domain: "<a href='https://restorationdentalgroup.com'>restorationdentalgroup.com</a>", // Fill this in
      email: "<a href='mailto:info@restorationdentalgroup.com'>info@restorationdentalgroup.com</a>", // Fill this in
      phone: "<a href='tel:+16305809880'>630.580.9880</a>", // Fill this in
      formattedEmail: ''
    }
  },
  mounted () {
    this.formatEmail()
  },
  methods: {
    formatEmail () {
      this.formattedEmail = '<a aria-label="email ' + this.email + '" href="mailto:' + this.email + '">' + this.email + '</a>'
    }
  }
}
</script>



// WEBPACK FOOTER //
// accessibility.vue?da583a5a